import React, { useState } from "react";

const ImmediateSubscribePage = () => {
  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    if (!email) {
      alert("メールアドレスを入力してください");
      return;
    }

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/payment/create-checkout-session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          planType: "immediate",
          email, // 👈 メールアドレスを送信
        }),
      });

      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("セッション作成に失敗しました");
      }
    } catch (err) {
      console.error("Stripeエラー:", err);
      alert("エラーが発生しました");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "400px", margin: "0 auto", textAlign: "center" }}>
      <h2>AdSche 再利用申し込み</h2>
      <p>再利用ご希望の方は、メールアドレスを入力し、再利用申し込みボタンを押してください。</p>

      <input
        type="email"
        placeholder="メールアドレスを入力"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ padding: "10px", marginBottom: "15px", width: "100%" }}
      />

      <br />

      <button
        onClick={handleSubscribe}
        style={{ padding: "10px 30px", fontSize: "16px" }}
      >
        再利用申し込み
      </button>
    </div>
  );
};

export default ImmediateSubscribePage;